var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "job-search",
        {
          attrs: { "search-areas": _vm.searchAreas },
          on: { "start-search": _vm.searchJobs },
        },
        [_vm._t("heroOverflowContent")],
        2
      ),
      _vm._v(" "),
      _vm.jobList
        ? _c(
            "job-list",
            { attrs: { "job-list": _vm.jobList } },
            [
              _vm.showErrorMessage
                ? _vm._t("errorMessage")
                : !_vm.jobList.length
                ? _vm._t("noResult")
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }